import "./MobileNav.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const MobileNav = () => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Prevent background scrolling when menu is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [isMenuOpen]);

    const handleNavClick = (path) => {
        navigate(path);
        setIsMenuOpen(false);
    };

    return (
        <>
            {/* Top-Left Hamburger Button */}
            <div className="mobile-hamburger-btn" onClick={() => setIsMenuOpen(true)}>
                <i className="fa-solid fa-bars-staggered"></i>
            </div>

            {/* Original Slide-Up Menu Overlay */}
            <div className={`mobile-menu-overlay ${isMenuOpen ? "open" : ""}`} onClick={() => setIsMenuOpen(false)}>
                
                {/* The White Slide-Up Content Box */}
                <div className="mobile-menu-content" onClick={(e) => e.stopPropagation()}>
                    <div className="menu-header">
                        <h4>Explore</h4>
                        <i className="fa-solid fa-xmark close-icon" onClick={() => setIsMenuOpen(false)}></i>
                    </div>
                    
                    <div className="menu-links-list">
                        <p onClick={() => handleNavClick("/allPaintings/All Paintings")}>Original Masterworks</p>
                        <p onClick={() => handleNavClick("/allPrints")}>Archival Prints</p>
                        <p onClick={() => handleNavClick("/customBiography")}>Custom Pictorial Biography</p>
                        <p onClick={() => handleNavClick("/contact")}>Contact Studio</p>
                        <p onClick={() => handleNavClick("/about")}>Artist</p>
                    </div>
                </div>

            </div>
        </>
    );
};

export default MobileNav;